/* All free solid fontawesome icons -> https://fontawesome.com/icons?d=gallery&s=solid&m=free */

import {
    faAngleDown,
    faAngleRight,
    faArrowLeft,
    faBars,
    faBookOpen,
    faChartArea,
    faChartBar,
    faChartPie,
    faChevronDown,
    faChevronUp,
    faCircle,
    faColumns,
    faSearch,
    faTable,
    faTachometerAlt,
    faUser,
    faEdit,
    faPencilAlt,
    faSave,
    faWindowClose,
    faUpload
} from '@fortawesome/free-solid-svg-icons';

export const fontAwesomeSolidIcons = {
    faAngleDown,
    faAngleRight,
    faArrowLeft,
    faBars,
    faBookOpen,
    faChartArea,
    faChartBar,
    faChartPie,
    faChevronDown,
    faChevronUp,
    faCircle,
    faColumns,
    faSearch,
    faTable,
    faTachometerAlt,
    faUser,
    faEdit,
    faPencilAlt,
    faSave,
    faWindowClose,
    faUpload
};
